import React, { Component } from 'react';

import './NanumSquareRound.scss';
import '../Webfont.scss';

class NanumSquareRoundStyle extends Component {
  render() {
    const {input} = this.props;

    return (
      <ul className="font_style-list nanum_squareround">
        <li className="weight_300">
          <span className="font_style-category">Light 300</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_400">
          <span className="font_style-category">Regular 400</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_700">
          <span className="font_style-category">Bold 700</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_800">
          <span className="font_style-category">ExtraBold 800</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
      </ul>
    );
  }
}

export default NanumSquareRoundStyle;